import React from "react"
import { Band, Location } from "@models/bands"
import { useBandEditForm } from "./BandEditFormContext"

const NYC_LAT = 40.710678
const NYC_LNG = -73.937254
const NYC_RADIUS_MILES = 90

function haversineMiles(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const toRad = (x: number) => (x * Math.PI) / 180
  const dlat = toRad(lat2 - lat1)
  const dlng = toRad(lng2 - lng1)
  const a =
    Math.sin(dlat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dlng / 2) ** 2
  return 3959 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

function sceneForLocation(location: Location | null): string | null {
  if (!location?.lat || !location?.lng) return null
  const miles = haversineMiles(NYC_LAT, NYC_LNG, Number(location.lat), Number(location.lng))
  return miles <= NYC_RADIUS_MILES ? "New York City" : "Everywhere Else"
}

interface BandSceneProps {
  band: Band
}

export const BandScene: React.FC<BandSceneProps> = ({ band }) => {
  const { form } = useBandEditForm()
  const location = form.watch("location") as Location | null

  const scene = sceneForLocation(location) ?? (band.scene_list
    ? band.scene_list.replace(/\b\w/g, (c) => c.toUpperCase())
    : null)

  return (
    <div className="lg:col-span-8 col-span-12 text-sm text-green-700 font-bold mb-2 pt-1">
      {scene ? (
        <>
          <span className="font-medium text-gray-700">Your Scene: </span>
          {scene}
        </>
      ) : (
        "Scene is assigned automatically based on your location."
      )}
    </div>
  )
}
